module.exports = __webpack_public_path__ + "static/img/wx.af6d726.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx.jpg
// module id = rZOy
// module chunks = 19